window.calculateCalories = function (weight, age, gender, activityLevel, goal) {
  let BMR;
  const assumedHeight = gender === "male" ? 170 : 160;

  if (gender === "male") {
    BMR = 88.36 + 13.4 * weight + 4.8 * assumedHeight - 5.7 * age;
  } else {
    BMR = 447.6 + 9.2 * weight + 3.1 * assumedHeight - 4.3 * age;
  }

  const activityMultipliers = {
    sedentary: 1.2,
    light: 1.375,
    moderate: 1.55,
    active: 1.725,
  };

  let TDEE = BMR * activityMultipliers[activityLevel];

  const goalAdjustments = {
    weight_loss: -500,
    muscle_gain: 0,
    health_management: 300,
  };

  let finalCalories = TDEE + goalAdjustments[goal];

  finalCalories = Math.round(finalCalories / 100) * 100;

  // Macronutrient Ratios (Based on Goal)
  let proteinRatio, fatRatio, carbRatio;

  if (goal === "muscle_gain") {
    dietType = "High-Protein & Balanced";
    proteinRatio = 0.35; // 35% Protein
    fatRatio = 0.25; // 25% Fat
    carbRatio = 0.4; // 40% Carbs
  } else if (goal === "weight_loss") {
    dietType = "High-Protein & Low-Carb";
    proteinRatio = 0.4; // 40% Protein
    fatRatio = 0.3; // 30% Fat
    carbRatio = 0.3; // 30% Carbs
  } else {
    dietType = "health_management";
    proteinRatio = 0.3; // 30% Protein
    fatRatio = 0.3; // 30% Fat
    carbRatio = 0.4; // 40% Carbs
  }

  function formatTitle(text) {
    return text
      .split("_") // Split by underscore
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(" "); // Join with space
  }

  return {
    calories: finalCalories,
    preferredDiet: formatTitle(dietType),
    macros: {
      protein: proteinRatio * 100 + "%",
      fat: fatRatio * 100 + "%",
      carbs: carbRatio * 100 + "%",
    },
  };
};
